<template>
  <div>
    <div class="container">
      <!-- select -->
      <div class="query-box">
        <Search
          :data="queryData"
          :field-list="fieldList"
          :list-type-info="listTypeInfo"
          @handleFilter="handleSearch"
          @handleReset="handleClear"
          :btnHidden="false"
          :count="100"
        ></Search>
      </div>
    </div>
    <div class="container">
      <div class="crumbs">
        <el-breadcrumb separator=" ">
          <el-breadcrumb-item style="float: right">
            <el-button style="margin-top: -10px" @click="handleExportDatail"
              >导出售后订单明细</el-button
            >
          </el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <TableList
        :loading="loading"
        :table-data="tableData"
        :table-label="tableLabel"
        :index-show="indexShow"
      >
        <!-- 操作 -->
        <template v-slot:operation="tData">
          <div>
            <eui-btn
                    v-if="Number(tData.scope.row.aftersalesStatus) !== 1"
                    @click="handleViewDetails(tData.scope.row)"
                    type="link"
                    fontSize="12px"
            >查看详情</eui-btn
            >
            <eui-btn
                    v-else
                    @click="handleViewDetailsTrue(tData.scope.row)"
                    type="link"
                    fontSize="12px"
            >查看并确认</eui-btn
            >
          </div>
        </template>
        <!-- 弹框 -->
      </TableList>
      <div class="pagination">
        <el-pagination
          prev-text="上一页"
          next-text="下一页"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page.sync="queryData.pageNum"
          :page-sizes="[10, 20, 50, 100, 200]"
          :page-size="queryData.pageSize"
          :total="pageTotal"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import TableList from '@/modules/projectA/components/common/e-table-list';
import Search from '@/modules/projectA/components/common/e-search';
import api from '@/modules/projectA/api/order';
import utils from '@/modules/projectA/utils/utils';
export default {
  name: 'afterSaleManage',
  components: {
    TableList,
    Search,
  },
  props: {},
  data() {
    return {
      queryData: {
        aftersalesNo: '',
        aftersalesStatus: '',
        aftersalesType: '',
        startTime: '',
        endTime: '',
        orderNo: '',
        purchaseCompanyName: '',
        pageNum: 1,
        pageSize: 10,
      },
      pageTotal: 0,
      indexShow: true,
      fieldList: [
        { label: '订单编号', type: 'input', value: 'orderNo' },
        { label: '售后单编号', type: 'input', value: 'aftersalesNo' },
        {
          label: '售后状态',
          type: 'select',
          value: 'aftersalesStatus',
          list: 'queryAfterSaleStatus',
          clearable: true,
        },
        { label: '采购商名称', type: 'input', value: 'purchaseCompanyName' },
        {
          label: '售后类型',
          type: 'select',
          value: 'aftersalesType',
          list: 'queryAfterSaleType',
          clearable: true,
        },
        {
          label: '申请售后时间',
          type: 'date',
          value: 'createTime',
          dateType: 'datetimerange',
          clearable: true,
        },
      ],
      listTypeInfo: {
        queryAfterSaleType: [
          { name: '退款', id: 1 },
          { name: '退货', id: 2 },
          { name: '换货', id: 3 },
          { name: '维修', id: 4 },
          { name: '补货', id: 5 },
        ],
        queryAfterSaleStatus: [
          { name: '已提交', id: 1 },
          { name: '已完成', id: 2 },
          { name: '已拒绝', id: 3 },
          { name: '已撤回', id: 4 },
        ],
      },

      loading: false,
      tableData: [],
      tableLabel: [
        {
          label: '订单编号',
          param: 'orderNo',
          align: 'center',
          width: '180',
        },
        {
          label: '采购商名称',
          param: 'purchaseCompanyName',
          align: 'center',
        },
        {
          label: '售后单编号',
          param: 'aftersalesNo',
          align: 'center',
          width: '190',
        },
        {
          label: '售后类型',
          param: 'aftersalesType',
          align: 'center',
          width: '90',
          render: (row) => {
            let str = '';
            switch (Number(row.aftersalesType)) {
              case 1:
                str = '退款';
                break;
              case 2:
                str = '退货';
                break;
              case 3:
                str = '换货';
                break;
              case 4:
                str = '维修';
                break;
              case 5:
                str = '补货';
                break;
            }
            return str;
          },
        },
        {
          label: '售后状态',
          param: 'aftersalesStatus',
          align: 'center',
          width: '90',
          render: (row) => {
            let obj = {
              1: '已提交',
              2: '已完成',
              3: '已拒绝',
              4: '已撤回',
            };
            return obj[row.aftersalesStatus];
          },
        },
        {
          label: '申请售后时间',
          param: 'createTime',
          align: 'center',
          width: '160',
        },
        {
          label: '操作',
          width: '140',
          fixed: 'right',
          align: 'center',
          slot: 'operation',
        },
      ],
      productTagPage: {
        currentPage: 1,
        pageSize: 10,
        pageTotal: 0,
      },
      afterSaleDetailDialogShow: false,
      afterSaleConfirmDialogShow: false,
    };
  },
  computed: {},
  activated() {
    const time = this.$route.query.t;
    console.log(this.$route.query);
    if (time && time !== this.uniqueId) {
      this.uniqueId = time;
      this.queryData = {
        aftersalesNo: '',
        aftersalesStatus: '',
        aftersalesType: '',
        startTime: '',
        endTime: '',
        orderNo: '',
        purchaseCompanyName: '',
        pageNum: 1,
        pageSize: 10,
      };
    }
  },
  mounted() {
    this.getData(this.queryData);
  },
  methods: {
    async getData(val) {
      await api.queryAftersalesListForAudit(val).then((res) => {
        if (res.code === '200') {
          this.tableData = res.data.records || [];
          this.pageTotal = res.data.total || 0;
        }
      });
    },

    async handleExportDatail() {
      await api.downloadAftersalesAuditList(this.queryData).then((res) => {
        if (res.type == 'application/json') {
          utils.fileExportResponseError(res);
        } else {
          utils.downFile(res);
        }
      });
    },

    // 查看详情
    handleViewDetails(row) {
      localStorage.setItem('afterSaleManageAffirm', JSON.stringify(row));
      this.$router.push({
        path: '/afterSaleManageAffirm',
        query: {
          type: 'orderDetail',
        },
      });
    },
    // 查看详情确认
    handleViewDetailsTrue(row) {
      localStorage.setItem('afterSaleManageAffirm', JSON.stringify(row));
      this.$router.push({
        path: '/afterSaleManageAffirm',
        query: {
          type: 'orderConfirm',
        },
      });

    },

    // 触发搜索按钮
    handleSearch(val) {
      let query = {
        aftersalesNo: val.aftersalesNo,
        aftersalesStatus: val.aftersalesStatus,
        aftersalesType: val.aftersalesType,
        startTime: val.createTime ? utils.parseTime(val.createTime[0]) : '',
        endTime: val.createTime ? utils.parseTime(val.createTime[1]) : '',
        orderNo: val.orderNo,
        purchaseCompanyName: val.purchaseCompanyName,
        pageNum: 1,
        pageSize: 10,
      };
      this.queryData = query;
      this.getData(query);
    },

    // 触发重置
    handleClear() {
      this.queryData.pageNum = 1;
      this.queryData.pageSize = 10;
      this.queryData.aftersalesType = '';
      this.queryData.aftersalesStatus = '';
      this.queryData.orderNo = '';
      this.queryData.aftersalesNo = '';
      this.queryData.purchaseCompanyName = '';
      this.getData(this.queryData);
    },

    handlePageChange(val) {
      this.queryData.pageNum = val;
      this.getData(this.queryData);
    },
  },
};
</script>

<style scoped></style>
